import { useQuery } from "@tanstack/react-query";
import { api } from "./client";

export type Me = {
  uid: number;
  user: string;
  name: string;
  is_admin: boolean;
  svc_role: string | null;
  balance_rub: number;
};

export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: () => api<Me>("/api/v1/me"),
    retry: false,
    staleTime: 60_000,
  });
}
